import { useMediaQuery } from 'react-responsive';
import { breakpoints, Card } from '@openedx/paragon';
import { Button } from 'components/ui/atoms/button';

export const DiscountProductCardSkeleton = () => {
  const isMobileView = useMediaQuery({ maxWidth: breakpoints.small?.maxWidth });
  const isMiniMobileView = useMediaQuery({
    maxWidth: breakpoints.extraSmall?.maxWidth,
  });

  return (
    <Card orientation={isMobileView ? 'vertical' : 'horizontal'} isLoading>
      <div className="position-relative tw-min-h-64">
        <Card.ImageCap
          src="/images/example-certificate-verified.png"
          srcAlt="Course image"
          className="card-image"
        />
      </div>
      <Card.Body>
        <Card.Header size="sm" />

        <Card.Section>&nbsp;</Card.Section>

        <Card.Footer
          orientation={isMiniMobileView ? 'horizontal' : 'vertical'}
          textElement="span"
        >
          <Button disabled aria-label="Loading">
            &nbsp;
          </Button>
        </Card.Footer>
      </Card.Body>
    </Card>
  );
};
